import { css } from "@emotion/css";
import React from "react";
import { iconStyles } from "./iconStyles";
export function EnvelopeIcon() {
    return (<svg className={styles} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 11C7.4375 11 7 11.5 7 12V13.4375L17.75 22.25C19.0625 23.3125 20.875 23.3125 22.1875 22.25L33 13.4375V12C33 11.5 32.5 11 32 11H8ZM7 17.3125V28C7 28.5625 7.4375 29 8 29H32C32.5 29 33 28.5625 33 28V17.3125L24.125 24.5625C21.6875 26.5625 18.25 26.5625 15.875 24.5625L7 17.3125ZM4 12C4 9.8125 5.75 8 8 8H32C34.1875 8 36 9.8125 36 12V28C36 30.25 34.1875 32 32 32H8C5.75 32 4 30.25 4 28V12Z"/>
        </svg>);
}
const styles = css(iconStyles);
